import {
  Component
} from '@angular/core';


export class SkyFilterInlineComponent {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-filter-inline',
  styles: [`.sky-filter-inline {
  background-color: #eeeeef;
  display: flex;
  padding: 10px;
  align-items: center;
}
`],
  template: `<div class="sky-filter-inline">
  <ng-content></ng-content>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
